import React, { useState } from 'react';
import { Field, FormSpy } from 'react-final-form';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { Box, StyledComponent, BoxProps, withDefaults, Button } from '@qwealth/qcore';

import { DateTimeStyle } from '../Styling';
import { RECURRENCE_PATTERN_TYPE } from 'data/refData/acitivites';

const Label = withDefaults<BoxProps>({
  as: 'label',
  display: 'grid',
  gridGap: 'small',
})(Box) as StyledComponent<BoxProps, HTMLLabelElement>;

const FIELD_SUBSCRIPTION = { error: true, value: true };

const Recurrence = ({ disabled }) => {
  const [showRecurring, setShowRecurring] = useState(false);

  return (
    <>
      <Box bg="gray.4" padding="large" borderRadius="default" my="large">
        <Button
          disabled={disabled}
          color="primary"
          variant="secondary"
          onClick={() => setShowRecurring(true)}
        >
          <FormSpy subscription={{ values: true }}>
            {({ values }) => `Repeat: ${values.recurrence.pattern.type.label}`}
          </FormSpy>
        </Button>
      </Box>

      <Modal show={showRecurring} onHide={() => setShowRecurring(false)}>
        <Modal.Header closeButton>Recurring Event</Modal.Header>
        <Modal.Body>
          <Box display="grid" gridAutoFlow="column" gridGap="default" mb="default">
            <Label textStyle="formLabel">
              Repeat
              <Field name="recurrence.pattern.type" subscription={FIELD_SUBSCRIPTION}>
                {({ meta: { error }, input }) => (
                  <>
                    <Select {...input} isDisabled={disabled} options={RECURRENCE_PATTERN_TYPE} />
                    {error && <Box color="error">{error}</Box>}
                  </>
                )}
              </Field>
            </Label>
          </Box>
          <Box display="grid" gridAutoFlow="column" gridGap="default" mb="default">
            <FormSpy subscription={{ values: true }}>
              {({ values }) =>
                values?.recurrence?.pattern.value !== 'never' && (
                  <>
                    <Label textStyle="formLabel">
                      End Date
                      <Field name="recurrence.range.endDate" subscription={FIELD_SUBSCRIPTION}>
                        {({ meta: { error }, input }) => (
                          <>
                            <DateTimeStyle
                              {...input}
                              timeFormat={false}
                              inputProps={{ disabled }}
                              timeConstraints={{ minutes: { step: 15, min: 0, max: 60 } }}
                            />
                            {error && <Box color="error">{error}</Box>}
                          </>
                        )}
                      </Field>
                    </Label>
                  </>
                )
              }
            </FormSpy>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Button onClick={() => setShowRecurring(false)}>Save</Button>
          </Box>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Recurrence;
